import { render, staticRenderFns } from "./trends.vue?vue&type=template&id=3142c872&scoped=true"
import script from "./trends.vue?vue&type=script&lang=js"
export * from "./trends.vue?vue&type=script&lang=js"
import style0 from "./trends.vue?vue&type=style&index=0&id=3142c872&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142c872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3142c872')) {
      api.createRecord('3142c872', component.options)
    } else {
      api.reload('3142c872', component.options)
    }
    module.hot.accept("./trends.vue?vue&type=template&id=3142c872&scoped=true", function () {
      api.rerender('3142c872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pricetrend/trends.vue"
export default component.exports